<template>
  <v-card class="pb-4 rounded-10" height="100%" style="overflow-y: auto">
    <v-card-text>
      <v-stepper
        v-model="currentStepIndex"
        vertical
        height="100%"
        flat
        class="pa-0"
      >
        <template v-for="(item, index) in items">
          <v-stepper-step
            :key="`step${index}`"
            :step="index + 1"
            :complete="completedSteps.includes(index + 1)"
            :color="completedSteps.includes(index + 1) ? 'success' : 'primary'"
            edit-icon="mdi-check"
            :editable="editable(index)"
            class="title-font"
            style="font-size: 17px"
          >
            <span class="d-flex align-center">
              {{ item.title }}
              <v-chip
                v-if="item.component.name === 'ChooseKit' && kitBoxID"
                class="ml-3"
                color="primary"
                x-small
              >
                {{ kitBoxID?.kit_box_id }}
              </v-chip>
              <v-chip
                v-if="item.component.name === 'CaseType' && sessionType"
                class="ml-3"
                color="primary"
                x-small
              >
                {{ capitalise(sessionType) }}
              </v-chip>
            </span>
          </v-stepper-step>
          <v-stepper-content
            :step="index + 1"
            :key="`content${index}`"
            class="pt-0"
          >
            <component
              :is="item.component"
              :is-active="index === currentStepIndex - 1"
              @next="currentStepIndex++"
              @step="setStep"
            />
          </v-stepper-content>
        </template>
      </v-stepper>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex"
import { capitalise } from "@/utils"
import KitAuthentication from "./MainCard/KitAuthentication.vue"
import CaseType from "./MainCard/CaseType.vue"
import UploadScans from "./MainCard/UploadScans.vue"
import ScanAnalysis from "./MainCard/ScanAnalysis.vue"
import LibraryAssociation from "./MainCard/LibraryAssociation.vue"
import PositionExport from "./MainCard/PositionExport.vue"

export default {
  name: "MainCard",

  components: {
    KitAuthentication,
    CaseType,
    UploadScans,
    ScanAnalysis,
    LibraryAssociation,
    PositionExport
  },

  data() {
    return {
      completedSteps: []
    }
  },

  watch: {
    stepIndex(step) {
      const openStep = this.items[step - 1]

      for (let s = 1; s < step; s++) {
        if (!this.completedSteps.includes(s)) this.completedSteps.push(s)
      }

      if (openStep.component === ScanAnalysis) {
        this.setTransition(true)
        var component = this.validateScansResponse
          ? "ValidatedDiv"
          : "SelectionDivs"
        return this.setPageState([{ cols: 7, component }])
      }
      if (openStep.component === LibraryAssociation)
        return this.setPageState([{ cols: 7, component: "AssociationDiv" }])

      return this.setPageState([{ cols: 7, component: "ConnectBranding" }])
    }
  },

  methods: {
    ...mapActions(["setPageState", "setTransition", "setStepIndex"]),

    capitalise,

    setStep(componentName) {
      const stepIndex = this.items.findIndex(
        (i) => i.component.name === componentName
      )
      if (stepIndex === 0) this.completedSteps = []
      this.currentStepIndex = stepIndex + 1
    },

    editable(index) {
      if (this.analyzerSession && index < 2) return false

      if (
        this.completedSteps.includes(index + 1) ||
        (index === this.completedSteps.length &&
          this.currentStepIndex !== index + 1)
      ) {
        return true
      }

      return false
    }
  },

  computed: {
    ...mapGetters([
      "settings",
      "validateScansResponse",
      "stepIndex",
      "analyzerSession",
      "isEmployee",
      "libraryAssociationResponse",
      "kitBoxID",
      "sessionType"
    ]),

    currentStepIndex: {
      get() {
        return this.stepIndex
      },

      set(value) {
        this.setStepIndex(value)
      }
    },

    items() {
      const steps = [
        { title: "CHOOSE CASE TYPE", component: CaseType },
        { title: "UPLOAD GAUGE SCANS", component: UploadScans },
        { title: "GAUGE SCAN ANALYSIS", component: ScanAnalysis }
      ]
      if (this.isEmployee) {
        steps.push(
          {
            title: "ENTER SCAN GAUGE KIT SERIAL NUMBER",
            component: KitAuthentication
          },
          { title: "LIBRARY ASSOCIATION", component: LibraryAssociation },
          {
            title: "EXPORT ABUTMENT POSITIONS",
            component: PositionExport
          }
        )
      }

      return steps
    }
  }
}
</script>
